import { Component, OnDestroy, OnInit } from '@angular/core';
import { time } from 'console';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription, interval } from 'rxjs';

@Component({
  selector: 'app-countdown',
  templateUrl: './countdown.component.html',
  styleUrls: ['./countdown.component.css']
})
export class CountdownComponent implements OnInit, OnDestroy {

  private subscription: Subscription;
  
  public dateNow = new Date();
  // public dDay = new Date('May 14 2021 00:00:00');
  public futureDate = new Date();
  inicioEleicao = false;
  milliSecondsInASecond = 1000;
  hoursInADay = 24;
  minutesInAnHour = 60;
  SecondsInAMinute  = 60;

  public timeDifference;
  public secondsToDday;
  public minutesToDday;
  public hoursToDday;
  public daysToDday;

  
  constructor(
    public spinner: NgxSpinnerService
  ) { }

    private getTimeDifference () {
    this.timeDifference = this.futureDate.getTime() - new  Date().getTime();
    this.allocateTimeUnits(this.timeDifference);
  }

  private allocateTimeUnits (timeDifference) {
      if(timeDifference >= 0) {
        this.secondsToDday = Math.floor((timeDifference) / (this.milliSecondsInASecond) % this.SecondsInAMinute);
        this.minutesToDday = Math.floor((timeDifference) / (this.milliSecondsInASecond * this.minutesInAnHour) % this.SecondsInAMinute);
        this.hoursToDday = Math.floor((timeDifference) / (this.milliSecondsInASecond * this.minutesInAnHour * this.SecondsInAMinute) % this.hoursInADay);
        this.daysToDday = Math.floor((timeDifference) / (this.milliSecondsInASecond * this.minutesInAnHour * this.SecondsInAMinute * this.hoursInADay));
      }else{
        this.inicioEleicao = true;
        this.secondsToDday = 0;
        this.minutesToDday = 0;
        this.hoursToDday = 0;
        this.daysToDday = 0;
      }

     }

  ngOnInit() {    
    this.futureDate = new Date(sessionStorage.getItem("dataHoraInicio"));

    console.log(this.futureDate)
    this.subscription = interval(1000)
        .subscribe(x => { this.getTimeDifference(); });

        this.spinner.hide();

  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}
